var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthdayPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 97,
    viewBox: "0 0 71 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9573 45.4544C28.6652 43.3032 31.6282 42.8285 34.1952 43.7588C36.7405 44.6812 38.6435 46.9456 38.5664 49.6618C38.4875 52.4401 36.528 54.7991 33.8596 55.5773C31.1958 56.3542 28.3361 55.3838 26.7787 53.0998C25.1968 50.7798 25.2007 47.6669 26.9573 45.4544Z",
    fill: "#EBFAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 36.9057V45.7301C12.1493 46.2225 13.6957 47.8696 16.0109 48.756C18.905 49.8639 21.1801 49.3537 25.5212 48.2457C29.8622 47.1378 34.8477 44.8903 39.3753 47.1676C42.9355 48.9584 45.2397 49.3239 49.2191 49.3239C52.4025 49.3239 57.2399 46.0895 59.0628 45.3707C59.0628 43.5242 58.6982 39.8189 58.6982 38.0462C58.6982 35.8304 57.2399 34.55 56.1462 34.3901C54.3337 34.125 18.905 34.7225 16.3727 34.7225C13.8404 34.7225 11.667 35.7978 11.667 36.9057Z",
    fill: "#00A3E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2295 18.6972V22.6447C18.5857 22.999 19.363 24.4427 21.0727 25.0804C23.2099 25.8775 24.89 25.5104 28.0957 24.7133C31.3014 23.9161 35.3027 22.8087 38.6462 24.4472C41.2752 25.7357 42.6571 25.489 45.5957 25.489C47.9465 25.489 51.1542 23.5269 52.5003 23.0097C52.5003 21.6812 52.1357 19.2539 52.1357 17.9785C52.1357 16.3842 51.4066 15.223 49.9482 14.9835C48.6264 14.7665 22.9442 14.4772 21.1462 14.9835C18.5941 15.7023 18.2295 17.9001 18.2295 18.6972Z",
    fill: "#00A3E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 64.4521V82.19C1.70588 83.1852 3.96884 86.5139 7.35708 88.3051C11.5924 90.5441 14.7277 91.5086 19.0628 89.5549C25.5655 86.6243 32 83.6084 41 87.1084C46.9124 89.4077 50.4487 90.5318 56.2722 90.5318C60.9311 90.5318 68.1937 83.4817 70 82.2285C70 78.4968 69.8277 70.2438 69.8277 66.6614C69.8277 62.1833 70.1229 60.8468 67.4712 60.2493C65.3037 59.7609 11.1418 59.6084 7.43592 59.6084C3.73004 59.6084 1 62.2131 1 64.4521Z",
    fill: "#00A3E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0269 70.9046C23.3196 72.9594 20.9185 74.8126 20.9187 75.7474C20.9187 75.8146 20.9268 75.8785 20.9521 75.9362C22.7187 79.9663 31.2699 82.9501 38.766 79.6742C46.2627 76.398 48.4257 69.8758 48.186 64.3166C48.1794 64.1605 48.112 64.0346 47.9908 63.9367C46.7979 62.9761 40.3267 64.7464 33.5237 67.7197C31.118 68.7708 28.9046 69.8637 27.0269 70.9046Z",
    fill: "white",
    stroke: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0361 76.1221C23.524 75.8203 26.8141 75.3557 29.6554 74.5064C37.4904 72.1645 43.3338 68.2133 47.3396 64.79",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0361 76.1221C23.524 75.8203 26.8141 75.3557 29.6554 74.5064C37.4904 72.1645 43.3338 68.2133 47.3396 64.79",
    stroke: "#1C1C1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 43.2704C12.9742 44.4642 16.6866 46.8004 21.0788 46.5958C26.569 46.34 27.7454 43.5262 34.0199 43.5262C40.2944 43.5262 41.0665 46.5958 48.1253 46.5958C55.1842 46.5958 55.7816 43.0146 58.3337 43.0146",
    stroke: "black",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2295 21.6056C19.169 22.3219 21.8373 23.7236 24.9942 23.6008C28.9403 23.4474 29.7859 21.7591 34.2957 21.7591C38.8055 21.7591 39.3604 23.6008 44.4339 23.6008C49.5075 23.6008 49.9369 21.4521 51.7712 21.4521",
    stroke: "black",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 86.0177C2.91993 87.9276 8.37255 91.6656 14.8235 91.3382C22.8873 90.9289 24.6152 86.4269 33.8309 86.4269C43.0466 86.4269 44.1805 91.3382 54.5482 91.3382C64.9158 91.3382 65.7933 85.6084 69.5417 85.6084",
    stroke: "black",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 63.3896C0.5 60.3521 2.96243 57.8896 6 57.8896H64C67.0376 57.8896 69.5 60.3521 69.5 63.3896V96.4209H0.5V63.3896Z",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 37.5146C11.4375 34.4771 13.8999 32.0146 16.9375 32.0146H53.0625C56.1001 32.0146 58.5625 34.4771 58.5625 37.5146V57.6084H11.4375V37.5146Z",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.8271C18 15.7896 20.4624 13.3271 23.5 13.3271H46.5C49.5376 13.3271 52 15.7896 52 18.8271V31.7334H18V18.8271Z",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.208 2.7959C28.208 1.86392 28.9635 1.1084 29.8955 1.1084C30.8275 1.1084 31.583 1.86392 31.583 2.7959V13.0459H28.208V2.7959Z",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6875 2.7959C37.6875 1.86392 38.443 1.1084 39.375 1.1084C40.307 1.1084 41.0625 1.86392 41.0625 2.7959V13.0459H37.6875V2.7959Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayPie);
export default __webpack_public_path__ + "static/media/birthday-pie.b23599e9ad4778ba1c6b726fb34f9cd4.svg";
export { ForwardRef as ReactComponent };